export default __webpack_public_path__ + "static/media/controllers.6f3d790a.png";